export const VERIFICATION_CODES = {
  ET001: 'emailVerificationTokenNotExist',
  PN001: 'invalidPhoneNumberFormat',
  PT001: 'forgotTokenNotFound',
  PT002: 'emailAlreadySent',
  PT003: 'forgotTokenExpired',
};
